export const easeInOutSine = (x: number): number =>
  -(Math.cos(Math.PI * x) - 1) / 2;

export const easeOutElastic = (x: number): number => {
  const c4 = (2 * Math.PI) / 3;

  if (x === 0) return 0;
  if (x === 1) return 1;

  return Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
};
